import React from 'react';

const SaveLoader = props => {
    const {visible = true, lightStyle = false, spacing= false} = props;

    if (!visible) {
        return null;
    }

    return <div
        className={'ch-icon-spinner ch-loader' + (lightStyle ? ' ch-loader-spinner-light' : '') + (spacing ? ' ch-loader-spacing' : '')}>
        <svg height="28px" viewBox="0 0 24 24" width="28px" fill="#000">
            <path
                d="m18.65 8.35-2.79 2.79c-.32.32-.1.86.35.86H18c0 3.31-2.69 6-6 6-.79 0-1.56-.15-2.25-.44-.36-.15-.77-.04-1.04.23-.51.51-.33 1.37.34 1.64.91.37 1.91.57 2.95.57 4.42 0 8-3.58 8-8h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.19-.2-.51-.2-.7-.01zM6 12c0-3.31 2.69-6 6-6 .79 0 1.56.15 2.25.44.36.15.77.04 1.04-.23.51-.51.33-1.37-.34-1.64C14.04 4.2 13.04 4 12 4c-4.42 0-8 3.58-8 8H2.21c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.31-.31.09-.85-.36-.85H6z"/>
        </svg>
    </div>;
}


export default SaveLoader;